import React, { useState } from 'react';
import styled from 'styled-components';

import EggFreezing from './attemptTypes/EggFreezing';
import IVF from './attemptTypes/IVF';
import { YellowButton } from '../../../../components/Buttons';
import { RetrievalResult } from '../types';
import PostopInstructionsModal from '../../../MyJourney/details/PostopInstructionsModal';

const DetailsOfRetrieval = (props: RetrievalResult) => {
  const { attemptType } = props;

  const [showModal, setShowModal] = useState(false);

  return (
    <>
      <Section>
        {attemptType === 'egg_freezing' ? <EggFreezing {...props} /> : <IVF {...props} />}
        <Button onClick={() => setShowModal(true)}>View post-op instructions</Button>
      </Section>
      <PostopInstructionsModal show={showModal} hide={() => setShowModal(false)} />
    </>
  );
};

const Section = styled.section`
  ${({ theme }) => theme.grid.container};
  border: solid 2px ${({ theme }) => theme.colors.nightMedium};

  @media ${({ theme }) => theme.queries.mobile} {
    padding: 0;
    border-left: none;
    border-right: none;
  }

  @media ${({ theme }) => theme.queries.desktop} {
    height: 100%;
  }

  h1 {
    ${({ theme }) => theme.typos.sectionHeader};
    color: ${({ theme }) => theme.colors.yellow};
    margin: 20px 0;
  }

  div {
    color: ${({ theme }) => theme.colors.white};

    p {
      strong {
        ${({ theme }) => theme.typos.bigNumber};
      }

      span {
        ${({ theme }) => theme.typos.unitSymbol};
        display: inline-block;
        margin-left: 6px;
        width: min-content;
      }

      @media ${({ theme }) => theme.queries.minTablet} {
        display: inline-block;
      }
    }
  }
`;

const Button = styled(YellowButton)`
  display: block;
  margin: 30px auto;
  width: max-content;
`;

export default DetailsOfRetrieval;
